<template>
    <v-col cols="12" md="6" lg="4" class="mb-3" flip="flop">
        <v-card>
            <v-card-title class="title font-weight-black">
                <v-icon class="pr-3">today</v-icon> Calendar Items Today
            </v-card-title>

            <v-card-text>
                <div v-if="loading">Loading...</div>
                <v-list>
                    <template v-for="(item, index) in notifications">
                        <v-list-item ripple v-bind:key="index" :href="item.url">
                            <v-list-item-subtitle class="list__item__subtitle">
                                <a :href="getItemUrl(item)"><b v-if="item.user">{{ item.user.first_name + " " + item.user.surname + " - " }}</b> {{ item.start_time }} - {{ item.end_time }}: {{ item.subject }} </a>
                                <a v-if="item.user && item.user.email" :href="getEmailUrl(item)"><v-icon>email</v-icon></a>
                            </v-list-item-subtitle>
                        </v-list-item>
                        <v-divider v-if="index + 1 < data.length" v-bind:key="index"></v-divider>
                    </template>
                </v-list>
            </v-card-text>

            <v-card-actions>
                <v-btn disabled><v-icon>add</v-icon> Add New</v-btn>
                <v-btn href="/calendar-events/list"><v-icon>list</v-icon> See Full List</v-btn>
                <v-btn href="/calendar-events/calendar" disabled><v-icon>today</v-icon> See Full Calendar</v-btn>
            </v-card-actions>
        </v-card>
    </v-col>

</template>

<script>
    import axios from 'axios';

    export default {
        props:['type'],
        data: function() {
            return {
                loading: true,
                data: []
            }
        },
        created:function() {
            this.fetchNotifications(true);
            setInterval( this.fetchNotifications ,60000 );
        },
        methods:{

            getItemUrl: function(item){
                return  "/calendar-events/" + item.calendar_event_key;
            },
            getEmailUrl: function(item){
                return  "mailto:" + item.user.email + "?subject=WRT " + item.subject;
            },

            fetchNotifications:function(){
                axios.get('/api/daily-calendar')
                .then(function(response){
                    this.data = response.data.notifications;
                    this.loading = false;
                }.bind(this));
            },

            formatYYYYMMDD(dateString){
                var date = new Date(Date.parse(dateString));

                var dd = date.getDate();
                var mm = date.getMonth()+1;
                var yyyy = date.getFullYear();
                if(dd<10) {dd='0'+dd}
                if(mm<10) {mm='0'+mm}
                return yyyy+'-'+mm+'-'+dd;
            },

            formatDateFromString(dateString){
                var dateFormatted = 'N/A';
                var date = Date.parse(dateString);

                var dd = date.getDate();
                var mm = date.getMonth()+1;
                var yyyy = date.getFullYear();
                if(dd<10) {dd='0'+dd}
                if(mm<10) {mm='0'+mm}
                date = yyyy+'-'+mm+'-'+dd;
                return dateFormatted;
            },
        },
        computed: {
            notifications: function(){
                return this.data;
            }
        }
    }
</script>

<style>
.news-list-item {
    height: auto;
}

a.v-btn:link {
    color: black !important;
}
</style>
